<template>
  <el-dialog :title="typeTitle" :visible.sync="dialogFormVisible" >
      <div v-loading="loading">
          <el-form :model="categoryForm" :rules="categoryRules" ref="ruleForm" label-width="100px">
              <el-form-item label="规格名称" prop="name">
                  <el-input v-model="categoryForm.name"></el-input>
              </el-form-item>
              <el-form-item label="商品分类" prop="categoryUuid">
                  <el-select filterable clearable  v-model="categoryForm.categoryUuid" placeholder="请选择商品分类" >
                      <el-option
                          v-for="(item,index) in options"
                          :key="index"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item prop="sort" label="排序">
                  <el-input-number v-model="categoryForm.sort" :min="1"></el-input-number>
              </el-form-item>
              <el-form-item label="输入框类型" prop="type">
                  <el-select v-model="categoryForm.type" placeholder="请选择输入框类型">
                      <el-option label="文本" value="INPUT"></el-option>
                      <el-option label="下拉框" value="SELECT"></el-option>
                      <el-option label="单选" value="RADIO"></el-option>
                      <el-option label="多选" value="CHECKBOX"></el-option>
                      <el-option label="日期" value="DATE"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="是否必填" prop="required">
                  <el-radio-group v-model="categoryForm.required">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                  </el-radio-group>
              </el-form-item>

              <div v-if="categoryForm.type == 'INPUT'">
                  <el-form-item label="是否为整数" prop="digits">
                      <el-radio-group v-model="categoryForm.digits">
                          <el-radio :label="true">是</el-radio>
                          <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                  </el-form-item>
                  <el-form-item label="内容长度" prop="length">
                      <el-input-number v-model="categoryForm.length" :min="1"></el-input-number>
                  </el-form-item>
                  <el-form-item label="单位" prop="unit">
                      <el-input v-model="categoryForm.unit"></el-input>
                  </el-form-item>
              </div>
              <div v-if="categoryForm.type == 'SELECT' || categoryForm.type == 'RADIO' || categoryForm.type == 'CHECKBOX'">
                  <el-form-item label="规格选项" prop="typeList">
                      <div style="position: relative;">
                          <div>
                              <div v-for="(item,index) in categoryForm.options"  :key="index" class="modelHeightRangeClass">
                                  <el-form-item :prop="'options.'+ index +'.value'" :rules="categoryRules.options">
                                      <el-input v-model="item.value" placeholder="请输入选项"></el-input>
                                  </el-form-item>
                                  <span v-if="index !== 0" style="padding-left: 30px;cursor: pointer;color: #157efb;line-height: 40px;" @click="delNext(index)">删除</span>
                              </div>
                              <el-button class="addNext" type="primary" size="small" @click="addOptions">点击添加下一条</el-button>
                          </div>
                      </div>
                  </el-form-item>
              </div>
          </el-form>

          <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false;reset">取 消</el-button>
              <el-button type="primary" @click="submitForm()">确 定</el-button>
          </div>
      </div>

  </el-dialog>
</template>

<script>
    import {


        saveShopStandard,

        getShopStandardInfo,
        typetree
    } from "../../../utils/interface";
    export default {
        data() {
          return {
            loading:false,
            dialogFormVisible: false,
            typeTitle:'',
            options:[],
            standardOptionList: [],
            awardList: [],
            categoryForm: {
              origin:'PLATFORM',
              sort:1,
              categoryUuid:'',
              name: '',
              resource: '',
              type:'',
              required: '',
              length: '',
              unit: '',
              multiple: '',
              options:[{
                  value:''
              }]
            },
            categoryRules: {
              name: [
                { required: true, message: '请输入规格名称', trigger: 'change' },
              ],
                sort: [
                    { required: true, message: '请输入排序', trigger: 'change' },
                ],
                categoryUuid: [
                    { required: true, message: '请选择分类', trigger: 'change' },
                ],
                type: [
                    { required: true, message: '请选择输入框类型', trigger: 'change' },
                ],
              required: [
                { required: true, message: '请选择是否必填', trigger: 'change' }
              ],

            }
          }
        },
        created() {

        },
        mounted(){

        },
        methods: {
            reset(){
                this.categoryForm = {
                    origin:'PLATFORM',
                    sort:1,
                    uuid:'',
                    categoryUuid:'',
                    name: '',
                    resource: '',
                    type:'',
                    required: '',
                    length: '',
                    unit: '',
                    multiple: '',
                    options:[{
                        value:''
                    }]
                }
                this.$nextTick(() => {
                    // DOM 更新了
                    console.log("dom update complete")
                    this.$refs["ruleForm"].clearValidate()
                })
            },
          init(type,uuid){
            this.loading=true;
            this.reset();
            if(type == 'edit'){
              this.typeTitle = '编辑'
                getShopStandardInfo(uuid).then((res) => {
                    if (res.success) {
                        this.categoryForm = res.data;
                    }
                    this.loading=false;
                });
            }else if(type == 'add'){
              this.typeTitle = '添加'
                this.loading=false;
            }
            this.typetree();
            this.dialogFormVisible = true
          },
          submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    //分类：平台
                    this.categoryForm.origin = 'PLATFORM';
                    saveShopStandard(this.categoryForm).then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                            this.dialogFormVisible = false;
                            this.$parent.getList()
                        }
                    });
                }else {
                    this.dialogFormVisible = true;
                }
            });
          },
        // 新增作品类别
        addOptions(){
            this.categoryForm.options.push({
                value: ''
            })
        },
        // 删除作品类别
        delNext(index){
            this.categoryForm.options.splice(index,1)
        },
          typetree(){
                let params = {
                    grade:"1",
                    type:'PLATFORM'
                };
                typetree(params).then((res)=>{
                    this.options = res;
                });
            }
        }
    }
</script>

<style scoped lang="less">
  .modelHeightRangeClass{
    display: flex;
    margin-bottom: 20px;
    /deep/.el-input__inner{
      width: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/commodityManagement/category/categoryMange.vue